import { render, staticRenderFns } from "./classroom.vue?vue&type=template&id=675eb5fc&scoped=true"
import script from "./classroom.vue?vue&type=script&lang=js"
export * from "./classroom.vue?vue&type=script&lang=js"
import style0 from "./classroom.vue?vue&type=style&index=0&id=675eb5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675eb5fc",
  null
  
)

export default component.exports